import { InvalidStateError } from 'utils/errors'
import { InvestStateErrors, type InvestStateStatus } from '../storage/invest-states'
import { showCurrentNetwork } from 'components/buttons'

export const getButtonText = (
  state: InvestStateStatus,
  isTransactionInPending: boolean,
  isProcessing: boolean,
): string => {
  switch (state.type) {
    case 'error':
      switch (isTransactionInPending) {
        case true:
          return 'Transaction in progress'
      }
      if (state.isRetry) {
        return 'Confirm transaction'
      }
      switch (state.payload) {
        case InvestStateErrors.Disconnected:
          return 'Connect wallet'
        case InvestStateErrors.UnsupportedNetwork:
          return `Switch to ${
            state.chainToSwitch ? showCurrentNetwork(state.chainToSwitch).name : 'Ethereum'
          }`
        case InvestStateErrors.ZeroAmount:
          return 'Enter amount'
        case InvestStateErrors.InsufficientAssetBalance:
          return 'Insufficient balance'
        case InvestStateErrors.InsufficientAllowance:
          return 'Insufficient allowance'
        case InvestStateErrors.EscrowPending:
          return 'Loading'
        // case InvestStateErrors.EscrowRecover:
        //   return 'Retry'
        case InvestStateErrors.RebalancePending:
          return 'Rebalancing in progress'
        default:
          throw new InvalidStateError(state)
      }
    case 'success':
      if (isProcessing) {
        return 'Preparing transaction'
      }
      switch (isTransactionInPending) {
        case false:
        default:
          if (state.payload.isRetry || state.payload.inputCurrency.type === 'native') {
            return 'Confirm transaction'
          }

          if (
            (!state.payload.isUserContract &&
              state.payload.permit === undefined &&
              state.payload.inputCurrency.permit !== undefined) ||
            (state.payload.isUserContract && state.payload.isApproval) ||
            (state.payload.inputCurrency.permit === undefined && state.payload.isApproval)
          ) {
            return `Approve ${state.payload.inputCurrency.symbol}`
          }
          return 'Confirm transaction'

        case true:
          return 'Transaction in progress'
      }

    default:
      throw new InvalidStateError(state)
  }
}
